module.exports = __webpack_public_path__ + "img/download-new.33275f49.svg";